import { RootState } from 'state/store';
import orderBy from 'lodash/orderBy';
import { insightDrilldownMetadataSelectors } from 'state/normalized/insightDrilldownMetadata/insightDrilldownMetadataSlice';
import {
  CapacityManagementDrillDownItem,
  EventDrillDownItem,
  ProjectDrillDownItem,
  RequestsDrillDownItem,
  TaskDrillDownItem,
  UserDrillDownItem,
} from 'types/store/normalized/insightsDrillDown';
import { insightDrilldownRequestsSelectors } from '../insightDrilldownRequests/insightDrilldownRequestsSlice';
import { insightDrilldownProjectsSelectors } from '../insightDrilldownProjects/insightDrilldownProjectsSlice';
import { insightDrilldownTasksSelectors } from '../insightDrilldownTasks/insightDrilldownTasksSlice';
import { insightDrilldownUsersSelectors } from '../insightDrilldownUsers/insightDrilldownUsersSlice';
import { cardTypeSelectors } from './cardTypeSlice';
import { insightDrilldownCapacityManagementSelectors } from '../insightDrilldownCapacityManagement/insightDrilldownCapacityManagmentSlice';
import { insightDrilldownFiltersSelectors } from '../insightDrilldownFilters/insightDrilldownFiltersSlice';
import { insightDrilldownEventsSelectors } from '../insightDrilldownEvents/insightDrilldownEventsSlice';
import { SortingType } from 'utils/customTypes';

/* =============================== SELECTORS ================================ */
const drilldownSelectors = {
  selectActiveDrilldownRequests: (
    state: RootState
  ): RequestsDrillDownItem[] => {
    const activeDrilldown =
      insightDrilldownMetadataSelectors.selectActiveDrilldown(state);
    if (activeDrilldown) {
      return insightDrilldownRequestsSelectors.selectRequestsByIds(
        state,
        activeDrilldown.entityIds
      );
    }
    return [];
  },
  selectActiveDrilldownProjects: (state: RootState): ProjectDrillDownItem[] => {
    const activeDrilldown =
      insightDrilldownMetadataSelectors.selectActiveDrilldown(state);
    if (activeDrilldown) {
      return insightDrilldownProjectsSelectors.selectProjectsByIds(
        state,
        activeDrilldown.entityIds
      );
    }
    return [];
  },
  selectActiveDrilldownTasks: (state: RootState): TaskDrillDownItem[] => {
    const activeDrilldown =
      insightDrilldownMetadataSelectors.selectActiveDrilldown(state);
    if (activeDrilldown) {
      return insightDrilldownTasksSelectors.selectTasksByIds(
        state,
        activeDrilldown.entityIds
      );
    }
    return [];
  },
  selectActiveDrilldownUsers: (state: RootState): UserDrillDownItem[] => {
    const activeDrilldown =
      insightDrilldownMetadataSelectors.selectActiveDrilldown(state);
    if (activeDrilldown) {
      return insightDrilldownUsersSelectors.selectUsersByIds(
        state,
        activeDrilldown.entityIds
      );
    }
    return [];
  },
  selectActiveDrilldownCapacityManagement: (
    state: RootState
  ): CapacityManagementDrillDownItem[] => {
    const activeDrilldown =
      insightDrilldownMetadataSelectors.selectActiveDrilldown(state);
    if (activeDrilldown) {
      return insightDrilldownCapacityManagementSelectors.selectCapacityManagementByIds(
        state,
        activeDrilldown.entityIds
      );
    }
    return [];
  },
  selectActiveDrilldownEvents: (
    state: RootState
  ): Array<EventDrillDownItem> => {
    const activeDrilldown =
      insightDrilldownMetadataSelectors.selectActiveDrilldown(state);
    if (activeDrilldown) {
      return insightDrilldownEventsSelectors.selectEventsByIds(
        state,
        activeDrilldown.entityIds
      );
    }
    return [];
  },
  selectActiveDrilldownEventsSorted: (
    state: RootState,
    orderByParam: string,
    order: SortingType
  ): Array<EventDrillDownItem> => {
    const events = drilldownSelectors.selectActiveDrilldownEvents(state);
    return orderBy(events, [orderByParam], [order]);
  },
  selectActiveDrilldownCardName: (state: RootState): string => {
    const activeDrilldown =
      insightDrilldownMetadataSelectors.selectActiveDrilldown(state);
    if (activeDrilldown) {
      return cardTypeSelectors.selectCardNameByInsightId(
        state,
        activeDrilldown.id
      );
    }
    return '';
  },
  selectInsightDrilldownFilters:
    insightDrilldownFiltersSelectors.selectInsightDrilldownFilters,
};

export default drilldownSelectors;
